import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class LMSCourseAttempt extends AdornisEntity {
  static override _class = 'LMSCourseAttempt';

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(() => Int)
  scorePercent: Maybe<number>;

  @Field(() => Boolean)
  passed: Maybe<boolean>;

  @Field(() => [LMSAttemptAnswer])
  answers: Maybe<LMSAttemptAnswer[]>;

  /** When this try was started (attempt creation). Absent on attempts created before this was tracked. */
  @Field(() => Date)
  startedAt: Maybe<Date>;

  @Field(() => Date)
  completedAt: Maybe<Date>;

  /** Client IP the attempt was started from (leftmost x-forwarded-for / x-real-ip). */
  @Field(() => String)
  ip: Maybe<string>;
}

@Entity()
export class LMSAttemptAnswer extends AdornisEntity {
  static override _class = 'LMSAttemptAnswer';

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(() => String)
  coursePageId: Maybe<string>;

  @Field(() => [String])
  selectedOptionIds: Maybe<string[]>;

  @Field(() => Boolean)
  isCorrect: Maybe<boolean>;
}
